const digest = '00167706b91092a4c75a57dbbb9c67f925a043a6a901f43fda25c10cd1af60b9';
const css = `._card_12zkv_1 a{
    text-decoration: underline;
} 

._btnWidth44_12zkv_5 {
    min-width: 44px !important;
    min-height: 44px !important;
    font-size: 13px;
  }`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'card': '_card_12zkv_1', 'btnWidth44': '_btnWidth44_12zkv_5' };
export const card = '_card_12zkv_1';
export const btnWidth44 = '_btnWidth44_12zkv_5';
export { css, digest };